import { lazy } from 'react'

const ReportingDashboard = lazy(async () => {
  const { Reporting } = await import(/* webpackChunkName: "reporting" */ './index')

  return {
    default: Reporting
  }
})
const routes = [
  {
    path: '/reporting/reports',
    exact: false,
    render(props) {
      return <ReportingDashboard {...props} />
    }
  }
]

export { routes }
